import { TLegalPage } from '@/reseller/reseller.types';

export const LEGAL_PAGES: Record<TLegalPage, string> = {
  terms_and_conditions: '/legal/sew-terms-and-conditions.html',
  data_processing_addendum: '/legal/sew-data-processing-addendum.html',
};
